export const fetchSubmissionStatsAction = (stats: any) => {
  return {
    type: "FETCH_SUBMISSION_STATS",
    payload: stats,
  };
};

export const fetchResourcesStatsAction = (stats: any) => {
  return {
    type: "FETCH_RESOURCES_STATS",
    payload: stats,
  };
};
